import styled from 'foundations-theming/utils';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { JUPITER_LAYER } from 'foundations-components/transitional/constants';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingSpinnerWrapper = styled.div.withConfig({
  displayName: "CenteredLoadingSpinner__LoadingSpinnerWrapper"
})([".hs-private.hs-private.hs-private &{width:100%;height:100%;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:", ";}"], JUPITER_LAYER);
export const CenteredLoadingSpinner = ({
  'data-test-id': dataTestId,
  'data-test-loading': dataTestLoading
}) => {
  return /*#__PURE__*/_jsx(LoadingSpinnerWrapper, {
    children: /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      "data-test-id": dataTestId,
      "data-test-loading": dataTestLoading,
      layout: "centered"
    })
  });
};